const translations = {
  en: {
    Start: "Start",
    End: "End",
    Zone: "Zone",
    "Active days": "Active days",
    "Device Serial": "Device Serial",
    "Last updated time": "Last updated time",
    "Will remove stored quick plan information": "Will remove stored quick plan information",
    "Are you sure?": "Are you sure?",
    "Will remove stored per day information": "Will remove stored per day information",
    "There are unsaved changes to the watering schedule": "There are unsaved changes to the watering schedule",
    "Select from quick plan templates or create your own.": "Select from quick plan templates or create your own.",
    "Create quick plan templates": "Create quick plan templates",
    "Each zone will be watered for selected number of minutes on selected days": "Each zone will be watered for selected number of minutes on selected days",
    "Start at": "Start at",
    "Water for": "Water for",
    Create: "Create",
    "Loading schedule data": "Loading schedule data",
    hour: "hour",
    day: "day",
    minute: "minute",
    Total: "Total",
    Quick: "Quick",
    Advanced: "Advanced",
    Common: "Common",
    "Per day": "Per day",
    Save: "Save",
    Mo: "Mo",
    Tu: "Tu",
    We: "We",
    Th: "Th",
    Fr: "Fr",
    Sa: "Sa",
    Su: "Su",
    Name: "Name",
    "Filter gardens by tags": "Filter Gardens By Tags",
    "Sun optimization": "Sun optimization",
    "Rain optimization": "Rain optimization",
    "Wind optimization": "Wind optimization",
    "Smart watering enabled": "Smart watering enabled",
    "Something went wrong while enabling smart watering": "Something went wrong while enabling smart watering",
    Yes: "Yes",
    No: "No",
    "Watering started": "Watering started",
    "Watering stopped": "Watering stopped",
    "Gardens assigned successfully": "Gardens assigned successfully",
    "Faulty phone number": "Faulty phone number",
    View: "View",
    Unassign: "Unassign",
    Stop: "Stop",
    "Start test": "Start test",
    "Successfully removed user": "Successfully removed user",
    "Garden is in test mode": "Garden is in test mode",
    "Test mode": "Test mode",
    "Test zone watering": "Test zone watering",
    "Device mode": "Device mode",
    TEST: "TEST",
    PSM: "PSM",
    NORMAL: "NORMAL",
    "User created successfully": "User created successfully",
    "Invitation has been sent to the user": "Invitation has been sent to the user",
    "Delete the user": "Delete the user",
    "Changes saved successfully": "Changes saved successfully",
    "Something went wrong while saving changes": "Something went wrong while saving changes",
    "Test state changed successfully": "Test state changed successfully",
    "Failed to change test state": "Failed to change test state",
    "Device unassigned successfully": "Device unassigned successfully",
    "Failed to unassign device": "Failed to unassign device",
    "Failed to send test command": "Failed to send test command",
    "Device assignments successful": "Device assignments successful",
    "devices assigned": "devices assigned",
    "Something went wrong": "Something went wrong",
    "While assigning devices": "While assigning devices",
    "Device removal successful": "Device removal successful",
    "devices removed from garden": "devices removed from garden",
    "While removing devices": "While removing devices",
    "Tag created successfully": "Tag created successfully",
    "While assigning gardens": "While assigning gardens",
    "Gardens removal successful": "Gardens removal successful",
    "gardens removed from  selected tags": "gardens removed from  selected tags",
    "While removing gardens": "While removing gardens",
    "User creation failed": "User creation failed",
    "Failed to remove user": "Failed to remove user",
    "Zoom level": "Minutes",
    "Last online": "Last online",
    "Garden name is required": "Garden name is required",
    "Map area polygon is required": "Map area polygon is required",
    "Test all valves (5 mins)": "Test all valves (5 mins)",
    Heat: "Heat",
    "Rain probability": "Rain probability",
    "Wind speed": "Wind speed",
    "Delete Garden": "Delete Garden",
    "Delete garden": "Delete Garden",
    "Are you sure you want to remove this garden?": "Are you sure you want to remove this garden?",
    "Water meter enabled": "Water meter enabled",
    Watering: "Watering",
    "Add time": "Add time",
    Signal: "Signal",
    Battery: "Battery",
    "Create device": "Create device",
    "Update device": "Update device",
    "Delete device": "Delete device",
    "Update device location": "Update device location",
    "Create garden": "Create garden",
    "Update garden": "Update garden",
    "Assign device": "Assign device",
    "Remove device": "Remove device",
    "Commit scheduler plans": "Commit scheduler plans",
    "Assign user": "Assign user",
    "Unassign user": "Unassign user",
    "Tag garden": "Tag garden",
    "Untag garden": "Untag garden",
    "Activate template": "Activate template",
    "Create plan": "Create plan",
    "Delete plan": "Delete plan",
    "Test watering": "Test watering",
    "Create quick plan template": "Create quick plan template",
    "Delete quick plan template": "Delete quick plan template",
    "Create tag": "Create tag",
    "Delete tag": "Delete tag",
    "No watering SMS": "No watering SMS",
    "Low watering SMS": "Low watering SMS",
    "Central Irrigation Management System": "Central Irrigation Management System",
    "Park/Garden Search": "Park/Garden Search",
    Yesterday: "Yesterday",
    "Irrigation Report": "Irrigation Report",
    "your device": "your device",
    Irrigation: "Irrigation",
    Active: "Active",
    Passive: "Passive",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",
    "Park/Garden Access": "Park/Garden Access",
    "Please select a user": "Please select a user",
    Suitable: "Suitable",
    "Assignable Parks/Gardens": "Assignable Parks/Gardens",
    Appointed: "Appointed",
    "Parks/Gardens Assigned to the User": "Parks/Gardens Assigned to the User",
    "Invite user with phone number": "Invite user with phone number",
    "Add User": "Add User",
    "Send invitation": "Send invitation",
    "Search for users": "Search for users",
    "Add Garden": "Add New Garden",
    Dashboard: "Dashboard",
    Users: "Users",
    Locations: "Locations",
    Devices: "Devices",
    Tags: "Tags",
    Reports: "Reports",
    Logout: "Logout",
    "Garden Name": "Garden Name",
    "Add Device To Garden": "Add device to the selected garden",
    Plans: "Plans",
    "New Plan": "New Plan",
    Mins: "mins",
    "Watering Days": "Watering Days",
    Cancel: "Cancel",
    "Last Update": "Last Update",
    "Zone Irrigation Test": "Zone Irrigation Test",
    "Test Time": "Test Time",
    "On Off": "On / Off",
    "5 min Sequential Test": "5 min Sequential Test",
    Latitude: "Latitude",
    Longitude: "Longitude",
    "Location Editable": "Location Editable",
    "Location Uneditable": "Location Uneditable",
    "Watering plans": "Watering Plans",
    "Start Time": "Start Time",
    "Active Days": "Active Days",
    "Valve Duration": "Valve Duration",
    "No Plans": "No Plans",
    Everyday: "Everyday",
    "Plan Created": "Plan Created",
    "Plan Created Successfully": "Plan Created Successfully",
    "Plan Creation Failed": "Plan Creation Failed",
    "Plan Deleted": "Plan Deleted",
    "Plan Deleted Successfully": "Plan Deleted successfully",
    "Plan Deletion Failed": "Plan Deletion Failed",
    "Location Edit": "Location Edit",
    On: "On",
    Off: "Off",
    Merged: "Merged",
    "Garden created successfully": "Garden created successfully",
    "Failed to create garden": "Failed to create garden",
    "Garden updated successfully": "Garden updated successfully",
    "Failed to update the garden": "Failed to update the garden",
    "Garden removed successfully": "Garden removed successfully",
    "Failed to remove garden": "Failed to remove garden",
    "Map geometry is empty": "Map geometry is empty",
    Loading: "Loading...",
    "Delete User Prompt": "Are you sure you want to delete this user?",
    "Logout Prompt": "Are you sure you want to log out?",
    "Zone Duration": "Zone Duration",
    "Total Duration": "Total Duration",
    "Update Garden": "Update Garden",
    "Save Changes": "Save Changes",
    "Add New User": "Add New User",
    "Super Admin": "Super Admin",
    "Technical Admin": "Admin",
    "Regional Manager": "Regional Manager",
    "Field Manager": "Site Manager",
    "Pro User": "Professional User",
    "Garden Tester": "Garden Tester",
    "End User": "Operator",
    technical_admin: "Admin",
    regional_manager: "Regional Manager",
    field_manager: "Site Manager",
    pro_user: "Professional User",
    garden_tester: "Site Tester",
    end_user: "Operator",
    "User Role": "User Role",
    Temperature: "Temperature",
    Rain: "Rain",
    Wind: "Wind",
    Sun: "Sun",
    "Show Optimization Settings": "Show Smart Watering Settings",
    "Plan Status": "Plan Status",
    Optimization: "Smart Watering",
    Shown: "Shown",
    Hidden: "Hidden",
    "Smart Watering": "Smart Watering",
    "Park Name": "Garden Name",
    History: "History",
    "Connected devices": "Connected devices",
    "Search device": "Search device",
    Ok: "Ok",
    "Change Device Name": "Change Device Name",
    "Device Updated": "Device Updated",
    "Are you sure you want to remove this device": "Are you sure you want to remove this device?",
    "Delete Device": "Delete Device",
    "Device removed successfully": "Device removed successfully",
    "Failed to remove device": "Failed to remove device",
    "Battery Modes": "Battery Modes",
    "Something went wrong. Please contact the administrator.": "Something went wrong. Please contact the administrator.",
    "Please enter your phone number to login": "Please enter your phone number to login",
    "Welcome to Grüngard": "Welcome to Grüngard",
    Phone: "Phone",
    "Send Code": "Send Code",
    "Watering Report": "Watering Report",
    "Please finish drawing to save": "Please finish drawing the garden borders in order to save.",
    Close: "Close",
    "This change cannot be reverted": "This change cannot be reverted",
    "Edit User Info": "Edit User Info",
    "Phone Number": "Phone Number",
    "An error occurred": "An error occurred",
    "User info updated successfully": "User info updated successfully",
    "Search by garden ID": "Search by garden ID",
    "Device Id": "Device Id",
    "Device Name": "Device Name",
    "Device Stock Id": "Device Stock Id",
    "Device Model": "Device Model",
    "Valve Count": "Valve Count",
    Durations: "Durations",
    "Plan Name": "Plan Name",
    "Garden Id": "Garden Id",
    "Garden Coordinates": "Garden Coordinates",
    "Watering Status": "Watering Status",
    "Inventory Query": "Inventory Query",
    "Template Ids": "Template Ids",
    Duration: "Duration",
    Type: "Type",
    "Order devices": "Order Devices",
    "Set Optimization": "Set Smart Watering",
    "User Id": "User Id",
    Gardens: "Gardens",
    "Work Orders": "Work Orders",
    Next: "Next",
    Previous: "Previous",
    "All Gardens": "All Gardens",
    Search: "Search",
    Creator: "Creator",
    Title: "Title",
    "Work Type": "Work Type",
    Completed: "Completed",
    "Creation Date": "Creation Date",
    "In Progress": "In Progress",
    Status: "Status",
    "Not Started": "Not Started",
    Waiting: "Waiting",
    Details: "Details",
    Notes: "Notes",
    "Work Order Details": "Work Order Details",
    "Device Unassigned": "Device Unassigned",
    "Show Garden": "Show Garden",
    "Start Location": "Start Location",
    "End Location": "End Location",
    Images: "Images",
    "Work Definition": "Work Definition",
    "Work Progress": "Work Progress",
    Employee: "Employee",
    "End Time": "End Time",
    "Employee Notes": "Employee Notes",
    "Work Location": "Work Location",
    Hours: "Hours",
    Minutes: "Minutes",
    Seconds: "Seconds",
    "Work Duration": "Work Duration",
    "New Work Order": "New Work Order",
    "Create Work Order": "Create Work Order",
    "Work Title": "Work Title",
    "Work Notes": "Work Notes",
    "Upload Photos (max 5)": "Upload Photos (max 5)",
    Upload: "Upload",
    Remove: "Remove",
    Garden: "Garden",
    "Work title is required": "Work title is required!",
    "Garden is required": "Garden is required!",
    "Work type is required": "Work type is required!",
    "Select Garden": "Select Garden",
    "Are you sure you want to remove this work order?": "Are you sure you want to remove this work order?",
    "Work Order Added": "Work Order Added",
    "User logged out successfully": "User logged out successfully",
    Submit: "Submit",
    "Send again": "Send again",
    "Enter the code": "Enter the code",
    "Battery mode updated": "Battery mode updated",
    Scheduler: "Scheduler",
    "operation(s)": "operation(s)",
    "Something went wrong while updating battery mode": "Something went wrong while updating battery mode",
    "There are no devices in this garden": "There are no devices in this garden",
    "No plan templates found": "There are no plan templates in this garden",
    "Work Order Deleted": "Work Order Deleted",
    "Update Battery Mode": "Update Battery Mode",
    "Battery Mode": "Battery Mode",
    "Show Work Order History": "Show Work Order History",
    "All Users": "All Users",
    Selectable: "Selectable",
    "Assignable Gardens": "Assignable Gardens",
    Assigned: "Assigned",
    "Gardens assigned to the tag": "Gardens assigned to the tag",
    "All templates are passive": "All templates are passive",
    "Daily water consumption limit": "Daily water consumption limit",
    "Daily consumption per m2": "Daily consumption per m2",
    "Park Area": "Garden Area",
    "Valve state updated successfully": "Valve state updated successfully",
    "Valve name updated successfully": "Valve name updated successfully",
    "Water meter updated successfully": "Water meter updated successfully",
    "Device coordinates updated successfully": "Device coordinates updated successfully",
    Success: "Success",
    Error: "Error",
    "Failed to send code": "Failed to send code",
    "Code sent": "Code sent",
    "Authentication failed": "Authentication failed",
    Observer: "Observer",
    Disabled: "Disabled",
    "Delete User": "Delete User",
    "Connection Dashboard": "Connection Dashboard",
    Refresh: "Refresh",
    "Update Device Data": "Update Device Data",
    "Valve Type": "Valve Type",
    "Delay Value": "Delay Value",
    "Applied To Device": "Applied To Device",
    "Not Applied To Device": "Not Applied To Device",
    Update: "Update",
    "Update Device Firmware": "Update Device Firmware",
    "Device Operations": "Device Operations",
    "Confirm Submission": "Confirm Submission",
    Confirm: "Confirm",
    "Connect device": "Connect device",
    Reset: "Reset",
    "Alarm Limit": "Alarm Limit",
    "Alarm limit updated successfully": "Alarm limit updated successfully",
    "Unsaved changes": "There are unsaved changes",
    Alarms: "Alarms",
    "In Alarm": "In Alarm",
    "Resolved Alarms": "Resolved Alarms",
    "Flow Rate Limit": "Flow Rate Limit",
    "Flow Rate Detected": "Flow Rate Detected",
    "Show Device": "Show Device",
    "Resolve Alarm": "Resolve Alarm",
    "There are devices with alarms": "There are devices with alarms",
    "Alarm Resolved": "Alarm Resolved",
    "Alarm has been resolved successfully": "Alarm has been resolved successfully",
    "Alarm Resolution Failed": "Alarm Resolution Failed",
    "Are you sure you want to resolve this alarm?": "Are you sure you want to resolve this alarm?",
    "No active alarms": "No active alarms",
    "Hide Notification": "Hide Notification",
    "Water Meter": "Water Meter",
    All: "All",
    Enabled: "Enabled",
    Select: "Select",
    "Apply Filter": "Apply Filter",
    "Green Area(m2)": "Green Area(m2)",
    "Garden Details": "Garden Details",
    "Edit Garden Info": "Edit Garden Info",
    "Garden Report": "Garden Report",
    "Manage Devices at Garden": "Manage Devices at Garden",
    "Edit Garden Name": "Edit Garden Name",
    "Edit Garden Map": "Edit Garden Map",
    "Manage Battery Modes": "Manage Battery Modes",
    "Work Orders History": "Work Orders History",
    "Device Details": "Device Details",
    "Reorder Devices": "Reorder Devices",
    rain: "Rain",
    wind: "Wind",
    sun: "Sun",
    "Quick Plans": "Quick Plans",
    "Advanced Plans": "Advanced Plans",
    Warning: "Warning",
    "This Week": "This Week",
    "This Month": "This Month",
    "Total Gardens": "Total Gardens",
    "Active Devices": "Active Devices",
    "Today's Watering": "Today's Watering",
    "Watering Trends": "Watering Trends",
    "Daily watering consumption chart": "Daily watering consumption chart",
    "Device Status": "Device Status",
    "Real-time device health monitoring": "Real-time device health monitoring",
    "Weather Impact": "Weather Impact",
    "Weather conditions vs irrigation efficiency": "Weather conditions vs irrigation efficiency",
    "Garden Performance": "Garden Performance",
    "Comparative analysis across gardens": "Comparative analysis across gardens",
    "Recent Activity": "Recent Activity",
    "System Status": "System Status",
    "Low battery detected in 3 devices": "Low battery detected in 3 devices",
    "Scheduled maintenance due tomorrow": "Scheduled maintenance due tomorrow",
    "All systems operational": "All systems operational",
    "Quick Actions": "Quick Actions",
    "Schedule Watering": "Schedule Watering",
    "Manage Devices": "Manage Devices",
    "View Reports": "View Reports",
    "Garden Alpha - Zone 1": "Garden Alpha - Zone 1",
    "Garden Beta - Zone 3": "Garden Beta - Zone 3",
    "Garden Gamma - Zone 2": "Garden Gamma - Zone 2",
    "Garden Alpha - Zone 4": "Garden Alpha - Zone 4",
    "Watering completed": "Watering completed",
    "Low battery alert": "Low battery alert",
    "Maintenance required": "Maintenance required",
    "Schedule updated": "Schedule updated",
    "2 min ago": "2 min ago",
    "15 min ago": "15 min ago",
    "1 hour ago": "1 hour ago",
    "2 hours ago": "2 hours ago",
    Today: "Today",
    "Unknown scheduler mode": "Unknown scheduler mode",
    "Garden Settings": "Garden Settings",
    "Edit Info": "Edit Info",
    "Redirects to Work Orders page": "Redirects to Work Orders page",
    "Green Area": "Green Area",
    "Daily Consumption": "Daily Consumption",
    "Custom Values": "Custom Values",
    "Not Set": "Not set yet",
    "Property Key": "Property Key",
    "Property Value": "Property Value",
    Add: "Add",
    "Cancel adding new property": "Cancel adding new property",
    "Add new property to GeoJSON properties": "Add new property to GeoJSON properties",
    "Delete property": "Delete property",
    "Edit Green Area": "Edit green area",
    "Garden Maps Configuration": "Garden Maps Configuration",
    "Manage Garden Devices": "Manage Garden Devices",
    "Search Devices": "Search Devices",
    Device: "Device",
    "Devices in tenant but not in a garden": "Devices in tenant but not in a garden",
    "Assignable Devices": "Assignable Devices",
    "Assigned Devices": "Assigned Devices",
    "Select All": "Select All",
    "Select Invert": "Select Invert",
    "No Devices Found": "No Devices Found",
    "Battery Saver Description": "Wakes up every 6 hours (period=21600)",
    "Normal Description": "Wakes up every 30 minutes (period=1800)",
    "Real Time Description": "Stays awake continuously",
    "Battery Modes Management by Garden": "Battery Modes Management by Garden",
    "Device Battery Modes Management": "Device Battery Modes Management",
    "Devices (available for Battery Mode management)": "Devices (available for Battery Mode management)",
    battery_saver: "Battery Saver",
    real_time: "Real Time",
    normal: "Normal",
    "Irrigation report is available only for BLT devices connected to a water meter.": "Irrigation report is available only for BLT devices connected to a water meter.",
    "Device Irrigation Report": "Device Irrigation Report",
    "Locate on Map": "Locate on Map",
    "Redirects to Garden page": "Redirects to Garden page",
    "Close Map": "Close Map",
    "Close Device View": "Close Device View",
    "The device you are looking for might have been removed or does not exist.": "The device you are looking for might have been removed or does not exist.",
    "Device is deleted or not found": "Device is deleted or not found",
    "Garden Area": "Garden Area",
    "Device Location": "Device Location",
    "Other Devices": "Other Devices",
    "Irrigation Zones": "Irrigation Zones",
    "Edit zone name": "Edit zone name",
    "Display Smart Water Meter": "Show Water Meter",
    "Close Smart Water Meter": "Close Water Meter",
    "No Connected Devices": "No Connected Devices",
    "Disconnect Device": "Disconnect Device",
    "Loading Map": "Loading Map",
    "Gardens Areas": "Gardens Areas",
    "All Devices": "All Devices",
    "Empty Battery Devices": "Empty Battery Devices",
    "Device Battery Filter": "Filter Devices By Battery",
    "Filter Devices By Model": "Filter Devices By Model",
    "View Garden Details": "View Garden Details",
    "Optimization Settings": "Smart Watering Settings",
    "Show Quick Plans": "Show Quick Plans",
    "Hide Quick Plans": "Hide Quick Plans",
    "Delete Quick Plan": "Delete Quick Plan",
    Now: "Now",
    "Quick plan deleted successfully": "Quick plan deleted successfully",
    Saving: "Saving",
    "Active on days": "Active on days",
    "Show days": "Show days",
    "Hide days": "Hide days",
    "Add Quick Plan": "Add Quick Plan",
    "Plans of": "Schedule",
    "Weekly Schedule": "Weekly Schedule",
    "Load Template": "Load Template",
    "No saved templates": "No saved templates",
    "Save Garden Template": "Save Garden Template",
    "Are you absolutely sure you want to load this template? This action will overwrite all current plans!":
      "Are you absolutely sure you want to load this template? This action will overwrite all current plans!",
    "Enter Template Name": "Enter Template Name",
    "Template Name": "Template Name",
    "Template applied": "Template applied",
    "These devices were not included in the template": "These devices were not included in the template",
    "Failed to apply template": "Failed to apply template",
    "Template saved": "Template saved",
    "Template applied successfully": "Template applied successfully",
    "Device plans were updated based on the selected template.": "Device plans were updated based on the selected template.",
    "Missing Devices": "Missing Devices",
    "These devices were included in the template but are no longer found in this garden":
      "These devices were included in the template but are no longer found in this garden",
    "New Devices Not in Template": "New Devices Not in Template",
    "These devices exist in the garden but were not included in the saved template": "These devices exist in the garden but were not included in the saved template",
    "No custom properties added yet.": "No custom properties added yet.",
    "Garden Is Passive": "Garden Is Passive",
    "No Active Plans": "No Active Plans",
    "Has Upcoming Plan": "Has Upcoming Plan",
    "Has No Upcoming Plans": "Has No Upcoming Plans",
    "Open Filters": "Open Filters",
    "Close Filters": "Close Filters",
    Filters: "Filters",
    Tag: "Tag",
    "No tags found": "No tags found",
    "All tags are in filtered state": "All tags are in filtered state",
    Clear: "Clear",
    "Hide Garden List": "Hide Garden List",
    batteryPercentage_all: "All Devices",
    batteryPercentage_full: "100%",
    batteryPercentage_threequarters: "> 75%",
    batteryPercentage_half: "> 50%",
    batteryPercentage_quarter: "> 25%",
    "batteryPercentage_lt-quarter": "< %25",
    batteryPercentage_empty: "Off Devices",
    "No gardens found": "No gardens found",
    "Apply Template": "Apply Template",
    "Cancel Preview": "Cancel Preview",
    "Preview Mode": "Preview Mode",
    "Rain Probability": "Rain Probability",
    "Wind Speed": "Wind Speed",
    Clients: "Clients",
    Employees: "Employees",
    "Affected Devices": "Affected Devices",
    "Upload Garden Image": "Upload Garden Image",
    "View Image": "View Image",
    "Hi! How can I help you?": "Hi! How can I help you?",
    Send: "Send",
    "Grüngard Assistant": "Grüngard Assistant",
    "Number of Active Valves": "Number of Active Valves",
    "Active Valve(s)": "Active Valve(s)",
    Saved: "Saved",
    Gizli: "Hidden",
    özel: "Private",
    "Tag Gardens": "Tag Gardens",
    "You can tag gardens to organize them better": "You can tag gardens to organize them better",
    "Create Tag": "Create Tag",
    "Create tag for gardens": "Create tag for gardens",
    "Delete selected tags": "Delete selected tags",
    "Tag selected": "Tag selected",
    item: "item",
    items: "items",
    "Audit Logs": "Audit Logs",
    "Templates viewed": "Templates viewed",
    "Show more": "Show more",
    "Not Modified": "Not Modified",
    "Watering disabled": "Watering disabled",
    "Watering enabled": "Watering enabled",
    "Unknown user": "Unknown user",
    "No audit logs found": "No audit logs found",
    "Last Week": "Last Week",
    Older: "Older",
    "User:": "User:",
    "Raw Data": "Raw Data",
    liters: "liters",
    gallon: "gallon",
    gallons: "gallons",
    "Update Device Location": "Update Device Location",
    "Cancel Location Update": "Cancel Location Update",
    "Device List": "Device List",
    Valves: "Valves",
    "Valve(s)": "Valves",
    "Valve": "Valve",
    "Go to garden": "Go to garden",
    "Park updated": "Garden updated",
    "Devices reordered": "Devices reordered",
    "Optimization set": "Smart Watering Set",
    "Device assigned": "Device assigned",
    "Device removed": "Device removed",
    "User assigned": "User assigned",
    "User unassigned": "User unassigned",
    "Park tagged": "Garden tagged",
    "Park untagged": "Garden untagged",
    "Template activated": "Template activated",
    "Scheduler plans committed": "Scheduler plans committed",
    "The authentication code has been sent to": "The authentication code has been sent to",
    "Manual watering": "Manual watering",
    "Hide Manual Watering": "Hide Manual Watering",
    min: "min",
    "Start Watering": "Start Watering",
    "Stop Watering": "Stop Watering",
    "Create a custom plan": "Create a custom plan",
    Day: "Day",
    Hour: "Hour",
    Minute: "Minute",
    "Custom Plan": "Custom Plan",
    "Zone Durations": "Zone Durations",
    "Start Times": "Start Times",
    "Every Day": "Every Day",
    Monday_short: "Mon",
    Tuesday_short: "Tue",
    Wednesday_short: "Wed",
    Thursday_short: "Thu",
    Friday_short: "Fri",
    Saturday_short: "Sat",
    Sunday_short: "Sun",
    "The phone number you've entered is in an invalid format": "The phone number you've entered is in an invalid format",
    "Phone number should be in 1xxxxxxxxxx format": "Phone number should be in 1xxxxxxxxxx format",
    "Gardens added to tag": "{{count}} gardens added to the selected tag",
    Devices_PL: "Devices",
    "Employee Name": "Employee Name",
    "Shift Report": "Shift Report",
    "Shift Start": "Shift Start",
    "Shift End": "Shift End",
    "Break Start": "Break Start",
    "Break End": "Break End",
    "Break Duration": "Break Duration",
    "Entry Location": "Entry Location",
    "Exit Location": "Exit Location",
    "Inside the Garden": "Inside the Garden",
    "Outside of the Garden": "Outside of the Garden",
    "Entry Notes": "Entry Notes",
    "Exit Notes": "Exit Notes",
    Breaks: "Breaks",
    Entry: "Entry",
    Exit: "Exit",
    "Shift Details": "Shift Details",
    "View on Map": "View on Map",
    "Select a garden to view optimizations": "Select a garden to view smart watering settings",
    "Optimizations for selected gardens": "Smart watering settings for selected gardens",
    "Please review the selected gardens and optimization settings before continuing.": "Please review the selected gardens and smart watering settings before continuing.",
    "Gardens to be affected": "Gardens to be affected",
    "Save Optimizations": "Save Smart Watering Settings",
    "Go Back": "Go Back",
    "These gardens will have their optimizations turned off": "These gardens will have their smart watering turned off",
    "Cancel Optimizations": "Cancel Smart Watering",
    "Display Alarm Limit": "Display Alarm Limit",
    "Close Alarm Limit": "Close Alarm Limit",
    "You will be notified": "You will be notified if more than {{alarmSettingsLimitLitres}} gallons are consumed within {{alarmSettingsDurationMinutes}} minutes.",
    "Alarm settings saved.": "Alarm settings saved.",
    "Alarm limit will be disabled.": "Alarm limit will be disabled.",
    "Optimizations cancelled successfully": "Smart Watering Has Been Disabled",
    "Optimizations saved successfully": "Smart Watering Settings Saved",
    "Rain rule": "If the chance of rain is above {{value}}, do not water.",
    "Temperature rule": "If the temperature is above {{value}}, increase watering.",
    "Wind rule": "If the wind speed is above {{value}}, do not water.",
    "Rain Forecast": "Rain Forecast",
    "High Temperature": "High Temperature",
    "High Winds": "High Winds",
    "Add at least one garden to list to configure optimizations.": "Add at least one garden to list to configure smart watering settings.",
    "Selected Gardens": "Selected Gardens",
    "Device valves data is missing": "Device valves data is missing",
    "Rain Optimization Active": "Rain Optimization Active",
    "Wind Optimization Active": "Wind Optimization Active",
    "Sun Optimization Active": "Sun Optimization Active",
    Legend: "Legend",
  },

  tr: {
    Start: "Başlangış",
    End: "Bitiş",
    Zone: "Bölge",
    "Active days": "Sulama Günleri",
    "Device Serial": "Cihaz Seri No",
    "Last updated time": "Plan Güncelleme",
    "Will remove stored quick plan information": "Tüm hızlı sulama planları devre dışı bırakılacak.",
    "Are you sure?": "Emin misiniz?",
    "Will remove stored per day information": "Günler için ayrı ayrı düzenlenmiş planları kaybedeceksiniz",
    "There are unsaved changes to the watering schedule": "Kaydetmediğiniz değişiklikler var.",
    "Select from quick plan templates or create your own.": "Hızlı plan taslaklarından seçebilirsiniz. Dilerseniz bu park için yeni hızlı plan yaratabilirsiniz.",
    "Create quick plan templates": "Hızlı plan taslağı oluşturun.",
    "Each zone will be watered for selected number of minutes on selected days": "Her bölge seçtiğiniz günlerde ayarladığınız süre kadar sulanacak.",
    "Start at": "Başlangıç",
    "Water for": "Sulama süresi",
    Create: "Kaydet",
    "Loading schedule data": "Sulama planları yükleniyor",
    technical_admin: "Teknik Yönetici",
    regional_manager: "Bölge Yöneticisi",
    field_manager: "Park Yöneticisi",
    day: "Gün",
    hour: "Saat",
    minute: "Dakika",
    Total: "Toplam",
    Quick: "Kolay",
    Advanced: "Detaylı plan",
    Common: "Tek gün",
    "Per day": "Tüm hafta",
    Save: "Kaydet",
    Mo: "Pt",
    Tu: "Sa",
    We: "Ça",
    Th: "Pe",
    Fr: "Cu",
    Sa: "Ct",
    Su: "Pa",
    Name: "İsim",
    "Filter gardens by tags": "Parkları Etiket ile Filtrele",
    "Sun optimization": "Sıcak",
    "Rain optimization": "Yağmur",
    "Wind optimization": "Rüzgar",
    "Smart watering enabled": "Akıllı sulama aktif",
    "Something went wrong while enabling smart watering": "Akıllı sulama ayarlarında bir sorun oluştu",
    Yes: "Evet",
    No: "Hayır",
    "Watering started": "Sulama başlatıldı",
    "Watering stopped": "Sulama durduruldu",
    "Gardens assigned successfully": "İşlem başarılı",
    "Check the information you entered": "Girdiğiniz bilgileri kontrol edin",
    "Faulty phone number": "Hatalı telefon numarası",
    View: "Parkı göster",
    Unassign: "Cihazı parktan çıkart",
    Stop: "Durdur",
    "Start test": "Başlat",
    "Successfully removed user": "Kullanıcı başarıyla silindi",
    "Garden is in test mode": "Park bakım moduna alındı.",
    "Test mode": "Bakım modu",
    "Test zone watering": "Bölge sulama testi",
    "Device mode": "Cihaz modu",
    TEST: "Bakım",
    PSM: "Uyku",
    NORMAL: "Erişilebilir",
    "User created successfully": "İşlem başarılı",
    "Invitation has been sent to the user": "Kullanıcı sisteme eklendi ve davet gönderildi",
    "Delete the user": "Kullanıcıyı sil",
    "Changes saved successfully": "Değişiklikler başarıyla kaydedildi.",
    "Something went wrong while saving changes": "Kayıt esnasında bir sorun oluştu.",
    "Test state changed successfully": "Bakım modu aktif",
    "Failed to change test state": "Bakım moduna geçilemedi",
    "Device unassigned successfully": "Cihaz parktan çıkarıldı",
    "Failed to unassign device": "Cihaz parktan çıkarılamadı",
    "Failed to send test command": "Test komutu gönderilemedi",
    "Device assignments successful": "Cihaz parka başarıyla eklendi",
    "devices assigned": "Cihazlar eklendi",
    "Something went wrong": "Bir sorun oluştu",
    "While assigning devices": "Cihazlar eklenirken",
    "Device removal successful": "Cihazlar kaldırma başarılı",
    "devices removed from garden": "Parktan kaldırılan cihazlar",
    "While removing devices": "Cihazları çıkarırken",
    "Tag created successfully": "Tag başarıyla oluşturuldu",
    "While assigning gardens": "Park atama işleminde hata",
    "Gardens removal successful": "Park kaldırma işlemi başarılı",
    "gardens removed from  selected tags": "Parklar kaldırıldı",
    "While removing gardens": "Park kaldırma işleminde hata",
    "User creation failed": "Kullanıcı oluşturma başarısız oldu",
    "Failed to remove user": "Kullanıcı kaldırılamadı",
    "Zoom level": "Dakika",
    "Last online": "Plan güncelleme",
    "Garden name is required": "Park ismi gereklidir.",
    "Map area polygon is required": "Lütfen haritadan parkı işaretleyin",
    "Test all valves (5 mins)": "5 dakika sıralı test",
    Heat: "Sıcaklık",
    "Rain probability": "Yağmur İhtimali",
    "Wind speed": "Rüzgar",
    "Delete Garden": "Parkı sil",
    "Delete garden": "Park silme",
    "Are you sure you want to remove this garden?": "Seçili parkı silmek istediğinize emin misiniz?",
    "Water meter enabled": "Akıllı Su Sayacı",
    Watering: "Su Tüketimi",
    "Add time": "Ekle",
    Signal: "Sinyal",
    Battery: "Pil",
    "Create device": "Cihaz ekleme",
    "Update device": "Cihaz güncelleme",
    "Delete device": "Cihaz silme",
    "Update device location": "Cihaz lokasyon güncelleme",
    "Create garden": "Park ekleme",
    "Update garden": "Park güncelleme",
    "Assign device": "Parka cihaz ekleme",
    "Remove device": "Parktan cihaz çıkartma",
    "Commit scheduler plans": "Detaylı plan işlemi",
    "Assign user": "Parka kullanıcı ekleme",
    "Unassign user": "Parktan kullanıcı çıkartma",
    "Tag garden": "Parka etiket ekleme",
    "Untag garden": "Parktan etiket çıkartma",
    "Activate template": "Hızlı plan seçimi",
    "Create plan": "Plan ekleme",
    "Delete plan": "Plan silme",
    "Test watering": "Test sulaması",
    "Create quick plan template": "Hızlı plan ekleme",
    "Delete quick plan template": "Hızlı plan silme",
    "Create tag": "Etiket yaratma",
    "Delete tag": "Etiket silme",
    "Battery Saver": "Pil Tasarrufu",
    Normal: "Normal",
    "Real Time": "Canlı",
    "mode activated": "modu aktif",
    "mode activation failed": "moduna geçilemedi",
    "No watering SMS": "Sulama yapılmadığında",
    "Low watering SMS": "Su miktarı değiştiğinde",
    "Notification SMS status": "SMS Bilgilendirme",
    "Low battery SMS": "Düşük pil bildirimi",
    "Will remove stored advanced plan information": "Geçiş yaptığınızda detaylı planlarınız iptal olacak.",
    "Update watering status for multiple parks": "Birden fazla park için sulama durumunu değiştirme",
    "Update watering status": "Sulama durumunu değiştir",
    "Created on": "Giriş tarihi",
    Logout: "Çıkış yap",
    "Central Irrigation Management System": "Merkezi Sulama Yönetim Sistemi",
    "Park/Garden Search": "Park/Bahçe Arama",
    Yesterday: "Dün",
    "Irrigation Report": "Sulama Raporu",
    "your device": "cihazınız",
    Irrigation: "Sulama",
    Active: "Aktif",
    Passive: "Pasif",
    Monday: "Pazartesi",
    Tuesday: "Salı",
    Wednesday: "Çarşamba",
    Thursday: "Perşembe",
    Friday: "Cuma",
    Saturday: "Cumartesi",
    Sunday: "Pazar",
    "Park/Garden Access": "Park/Bahçe Erişim",
    "Please select a user": "Lütfen bir kullanıcı seçin",
    Suitable: "Uygun",
    "Assignable Parks/Gardens": "Atanabilir Parklar/Bahçeler",
    Appointed: "Atanan",
    "Parks/Gardens Assigned to the User": "Kullanıcıya Atanan Parklar/Bahçeler",
    "Invite user with phone number": "Telefon numarası ile kullanıcı ekleyin",
    "Add User": "Kullanıcı Ekle",
    "Send invitation": "Davetiye gönder",
    "Search for users": "Kullanıcı ara",
    "Add Garden": "Park Ekle",
    Dashboard: "Gösterge Paneli",
    Users: "Kullanıcılar",
    Locations: "Konumlar",
    Devices: "Cihazlar",
    Tags: "Etiketler",
    Reports: "Raporlar",
    "Garden Name": "Park Adı",
    "Add Device To Garden": "Seçili parka cihaz ekleyin",
    Plans: "Planlar",
    "New Plan": "Yeni Plan",
    Mins: "dk",
    "Watering Days": "Sulama Günleri",
    Cancel: "İptal",
    "Last Update": "Son Güncelleme",
    "Zone Irrigation Test": "Bölge Sulama Testi",
    "Test Time": "Test Süresi",
    "On Off": "Açık / Kapalı",
    "5 min Sequential Test": "5 Dakikalık Sıralı Test",
    Latitude: "Enlem",
    Longitude: "Boylam",
    "Location Editable": "Konum Düzenlenebilir",
    "Location Uneditable": "Konum Düzenlenemez",
    "Watering plans": "Sulama Planları",
    "Start Time": "Başlangıç Zamanı",
    "Active Days": "Aktif Günler",
    "Valve Duration": "Vana Süresi",
    "No Plans": "Plan Yok",
    Everyday: "Her Gün",
    "Plan Created": "Plan oluşturuldu",
    "Plan Created Successfully": "Plan başarıyla oluşturuldu",
    "Plan Creation Failed": "Plan oluşturma başarısız",
    "Plan Deleted": "Plan silindi",
    "Plan Deleted Successfully": "Plan başarıyla silindi",
    "Plan Deletion Failed": "Plan silme başarısız",
    "Location Edit": "Konum Düzenleme",
    On: "Açık",
    Off: "Kapalı",
    Merged: "Birleştir",
    "Garden created successfully": "Park oluşturuldu.",
    "Failed to create garden": "Park oluşturulamadı. Farklı bir park adı ile tekrar deneyiniz.",
    "Garden updated successfully": "Park güncellendi.",
    "Failed to update the garden": "Park güncelleme başarısız.",
    "Garden removed successfully": "Park silindi.",
    "Failed to remove garden": "Park silme başarısız.",
    "Map geometry is empty": "Lütfen harita üzerinden konum belirleyiniz.",
    Loading: "Yükleniyor...",
    "Delete User Prompt": "Seçili kullanıcıyı silmek istediğinize emin misiniz?",
    "Logout Prompt": "Çıkış yapmak istediğinize emin misiniz?",
    "Zone Duration": "Bölge Süresi",
    "Total Duration": "Toplam Süre",
    "Update Garden": "Parkı düzenle",
    "Save Changes": "Değişiklikleri Kaydet",
    "Add New User": "Kullanıcı Ekle",
    "Super Admin": "Sistem Yöneticisi",
    "Technical Admin": "Teknik Yönetici",
    "Regional Manager": "Bölge Yöneticisi",
    "Field Manager": "Park Yöneticisi",
    "Pro User": "Profesyonel Kullanıcı",
    "End User": "Son Kullanıcı",
    end_user: "Son Kullanıcı",
    garden_tester: "Park Çalışanı",
    "User Role": "Kullanıcı Rolü",
    Temperature: "Sıcaklık",
    Rain: "Yağmur",
    Wind: "Rüzgar",
    Sun: "Güneş",
    "Show Optimization Settings": "Akıllı Sulama Ayarlarını Göster",
    "Plan Status": "Plan Durumu",
    Optimization: "Akıllı Sulama",
    Shown: "Gösteriliyor",
    Hidden: "Gizli",
    "Smart Watering": "Akıllı Sula",
    "Park Name": "Park Adı",
    History: "Geçmiş",
    "Connected devices": "Bağlı cihazlar",
    "Search device": "Cihaz ara",
    Ok: "Tamam",
    "Change Device Name": "Cihaz Adı Düzenleme",
    "Device Updated": "Cihaz Güncellendi",
    "Are you sure you want to remove this device": "Seçili cihazı silmek istediğinize emin misiniz?",
    "Delete Device": "Cihazı Sil",
    "Device removed successfully": "Cihaz silindi",
    "Failed to remove device": "Cihaz silme başarısız",
    "Battery Modes": "Pil Modları",
    "Something went wrong. Please contact the administrator.": "Bir hata oluştu. Lütfen sistem yöneticisi ile iletişime geçiniz",
    "Please enter your phone number to login": "Lütfen giriş yapmak için telefon numaranızı giriniz",
    "Welcome to Grüngard": "Grüngard'a Hoş Geldiniz",
    Phone: "Telefon",
    "Send Code": "Kod Gönder",
    "Watering Report": "Sulama Raporu",
    "Please finish drawing to save": "Kaydetmek için lütfen çizim işlemini tamamlayınız.",
    Close: "Kapat",
    "This change cannot be reverted": "Bu değişiklik geri alınamaz!",
    "Edit User Info": "Kullanıcı Bilgisi Düzenleme",
    "Phone Number": "Telefon Numarası",
    "An error occurred": "Bir hata oluştu",
    "User info updated successfully": "Kullanıcı bilgileri güncellendi",
    "Search by garden ID": "Park ID ile ara",
    "Device Id": "Cihaz Id",
    "Device Name": "Cihaz Adı",
    "Device Stock Id": "Stok Id",
    "Device Model": "Model",
    "Valve Count": "Bölge Sayısı",
    Durations: "Süre",
    "Plan Name": "Plan Adı",
    "Garden Id": "Park Id",
    "Garden Coordinates": "Park Koordinatları",
    "Watering Status": "Sulama Durumu",
    "Inventory Query": "Envanter Sorgulama",
    "Template Ids": "Taslak Id",
    Duration: "Süre",
    Type: "Tür",
    "Order devices": "Cihaz Sıralama",
    "Set Optimization": "Akıllı Sulama",
    "User Id": "Kullanıcı Id",
    Gardens: "Parklar",
    "Work Orders": "İş Emirleri",
    Next: "Sonraki",
    Previous: "Önceki",
    "All Gardens": "Tüm Parklar",
    Search: "Ara",
    Creator: "Oluşturan",
    Title: "Başlık",
    "Work Type": "İş Türü",
    Completed: "Tamamlandı",
    "Creation Date": "Oluşturulma Tarihi",
    "In Progress": "Devam Ediyor",
    Status: "Durum",
    "Not Started": "Başlanmadı",
    Waiting: "Beklemede",
    Details: "Detaylar",
    Notes: "Notlar",
    "Work Order Details": "İş Emri Detayları",
    "Device Unassigned": "Cihaz Boşta",
    "Show Garden": "Parkı Göster",
    "Start Location": "Başlangıç Konumu",
    "End Location": "Tamamlanma Konumu",
    Images: "Görseller",
    "Work Definition": "İş Tanımı",
    "Work Progress": "Çalışma Durumu",
    Employee: "Personel",
    "End Time": "Tamamlanma Zamanı",
    "Employee Notes": "Personel Notları",
    "Work Location": "Çalışma Konumu",
    Hours: "Saat",
    Minutes: "Dakika",
    Seconds: "Saniye",
    "Work Duration": "Çalışma Süresi",
    "New Work Order": "Yeni İş Emri",
    "Create Work Order": "İş Emri Oluştur",
    "Work Title": "Başlık",
    "Work Notes": "İş Notları",
    "Upload Photos (max 5)": "Görsel Yükle (en fazla 5 adet)",
    Upload: "Yükle",
    Remove: "Sil",
    Garden: "Park",
    "Work title is required": "Lütfen başlık belirleyiniz",
    "Garden is required": "Lütfen park seçiniz",
    "Work type is required": "Lütfen iş türünü seçiniz",
    "Select Garden": "Park Seçiniz",
    "Are you sure you want to remove this work order?": "Seçili iş emrini silmek istediğinize emin misiniz?",
    "Work Order Added": "İş Emri Eklendi",
    "User logged out successfully": "Oturum sonlandırıldı",
    Submit: "Gönder",
    "Send again": "Tekrar Kod Gönder",
    "Enter the code": "Kod giriniz",
    "Battery mode updated": "Pil modu güncellendi",
    Scheduler: "Zamanlayıcı",
    "operation(s)": "işlem",
    "Something went wrong while updating battery mode": "Pil modu güncelleme işleminde bir hata oluştu",
    "There are no devices in this garden": "Bu parkta cihaz bulunmamaktadır",
    "No plan templates found": "Bu parkta plan taslağı bulunmamaktadır",
    "Work Order Deleted": "İş emri silindi",
    "Update Battery Mode": "Pil Modu Güncelleme",
    "Battery Mode": "Pil Modu",
    "Show Work Order History": "İş Emri Geçmişini Görüntüle",
    "All Users": "Tüm Kullanıcılar",
    Selectable: "Seçilebilir",
    "Assignable Gardens": "Atanabilir Parklar",
    Assigned: "Atanmış",
    "Gardens assigned to the tag": "Etikete atanmış parklar",
    "All templates are passive": "Aktif plan bulunmamaktadır",
    "Daily water consumption limit": "Günlük su tüketim limiti",
    "Daily consumption per m2": "Metrekare başına günlük tüketim",
    "Park Area": "Park Alanı",
    "Valve state updated successfully": "Bölge durumu güncellendi",
    "Valve name updated successfully": "Bölge adı güncellendi",
    "Water meter updated successfully": "Su sayacı güncellendi",
    "Device coordinates updated successfully": "Cihaz konumu güncellendi",
    Success: "Başarılı",
    Error: "Hata",
    "Failed to send code": "Kod gönderilemedi",
    "Code sent": "Kod gönderildi",
    "Authentication failed": "Doğrulama başarısız",
    "Garden Tester": "Park Çalışanı",
    Observer: "Gözlemci",
    Disabled: "Devre Dışı",
    "Delete User": "Kullanıcıyı Sil",
    "Connection Dashboard": "Bağlantı Paneli",
    Refresh: "Yenile",
    "Update Device Data": "Cihaz Bilgilerini Güncelle",
    "Valve Type": "Vana Türü",
    "Delay Value": "Gecikme Değeri",
    "Applied To Device": "Cihaza Yazıldı",
    "Not Applied To Device": "Cihaza Yazılmadı",
    "Update Device Firmware": "Cihaz Yazılımını Güncelle",
    Update: "Güncelle",
    "Device Operations": "Cihaz İşlemleri",
    "Confirm Submission": "Gönderilecek Verileri Kontrol Ediniz",
    Confirm: "Onayla",
    "Connect device": "Cihaz bağla",
    Reset: "Sıfırla",
    "Alarm Limit": "Alarm Limiti",
    "Alarm limit updated successfully": "Alarm limiti güncellendi",
    "Unsaved changes": "Kaydedilmemiş değişiklikler mevcut",
    Alarms: "Alarmlar",
    "In Alarm": "Aktif",
    "Resolved Alarms": "Geçmiş",
    "Flow Rate Limit": "Tüketim Limiti",
    "Flow Rate Detected": "Tespit Edilen Tüketim",
    "Show Device": "Cihazı Göster",
    "Resolve Alarm": "Alarmı Durdur",
    "There are devices with alarms": "Su Tüketim Alarmı Veren Cihazlar Mevcut",
    "Alarm Resolved": "Alarm Durduruldu",
    "Alarm has been resolved successfully": "Alarm durdurma işlemi başarılı",
    "Alarm Resolution Failed": "Alarm durdurma işlemi başarısız",
    "Are you sure you want to resolve this alarm?": "Bu alarmı durdurmak istediğinize emin misiniz?",
    "No active alarms": "Aktif alarm bulunmamaktadır",
    "Hide Notification": "Bildirimi Gizle",
    "Water Meter": "Su Sayacı",
    All: "Tümü",
    Enabled: "Aktif",
    Select: "Seçiniz",
    "Apply Filter": "Filtrele",
    "Green Area(m2)": "Yeşil Alan(m2)",
    "Garden Details": "Park Bilgileri",
    "Edit Garden Info": "Park Bilgilerini Düzenle",
    "Garden Report": "Park Raporu",
    "Manage Devices at Garden": "Park Cihazlarını Yönet",
    "Edit Garden Name": "Park adını düzenle",
    "Edit Garden Map": "Haritayı Düzenle",
    "Manage Battery Modes": "Pil Modlarını Yönet",
    "Work Orders History": "İş Emirleri Geçmişi",
    "Device Details": "Cihaz Detayları",
    "Reorder Devices": "Cihazları Sırala",
    rain: "Yağmur",
    wind: "Rüzgar",
    sun: "Sıcaklık",
    "Quick Plans": "Kolay Planlar",
    "Advanced Plans": "Detaylı Planlar",
    Warning: "Uyarı",
    "This Week": "Bu Hafta",
    "This Month": "Bu Ay",
    "Total Gardens": "Toplam Parklar",
    "Active Devices": "Aktif Cihazlar",
    "Today's Watering": "Bugünün Sulaması",
    "Watering Trends": "Sulama Eğilimleri",
    "Daily watering consumption chart": "Günlük sulama tüketim grafiği",
    "Device Status": "Cihaz Durumu",
    "Real-time device health monitoring": "Gerçek zamanlı cihaz sağlığı izleme",
    "Weather Impact": "Hava Durumu Etkisi",
    "Weather conditions vs irrigation efficiency": "Hava koşulları ve sulama verimliliği",
    "Garden Performance": "Park Performansı",
    "Comparative analysis across gardens": "Parklar arası karşılaştırmalı analiz",
    "Recent Activity": "Son Aktiviteler",
    "System Status": "Sistem Durumu",
    "Low battery detected in 3 devices": "3 cihazda düşük pil tespit edildi",
    "Scheduled maintenance due tomorrow": "Yarın planlı bakım var",
    "All systems operational": "Tüm sistemler çalışıyor",
    "Quick Actions": "Hızlı İşlemler",
    "Schedule Watering": "Sulama Planla",
    "Manage Devices": "Cihazları Yönet",
    "View Reports": "Raporları Görüntüle",
    "Garden Alpha - Zone 1": "Alpha Parkı - Bölge 1",
    "Garden Beta - Zone 3": "Beta Parkı - Bölge 3",
    "Garden Gamma - Zone 2": "Gamma Parkı - Bölge 2",
    "Garden Alpha - Zone 4": "Alpha Parkı - Bölge 4",
    "Watering completed": "Sulama tamamlandı",
    "Low battery alert": "Düşük pil uyarısı",
    "Maintenance required": "Bakım gerekli",
    "Schedule updated": "Plan güncellendi",
    "2 min ago": "2 dakika önce",
    "15 min ago": "15 dakika önce",
    "1 hour ago": "1 saat önce",
    "2 hours ago": "2 saat önce",
    Today: "Bugün",
    "Unknown scheduler mode": "Bilinmeyen zamanlayıcı modu",
    "Garden Settings": "Park Ayarları",
    "Edit Info": "Bilgileri Düzenle",
    "Redirects to Work Orders page": "İş Emirleri sayfasına yönlendirir",
    "Green Area": "Yeşil Alan",
    "Daily Consumption": "Günlük Tüketim",
    "Custom Values": "Özel Değerler",
    "Not Set": "Henüz tanımlanmadı",
    "Property Key": "Özellik Anahtarı",
    "Property Value": "Özellik Değeri",
    Add: "Ekle",
    "Cancel adding new property": "Yeni özellik ekleme işlemini iptal et",
    "Add new property to GeoJSON properties": "GeoJSON özelliklerine yeni özellik ekle",
    "Delete property": "Özelliği sil",
    "Edit Green Area": "Yeşil alanı düzenle",
    "Garden Maps Configuration": "Park Harita Ayarları",
    "Manage Garden Devices": "Park Cihazlarını Yönet",
    "Search Devices": "Cihaz Ara",
    Device: "Cihaz",
    "Devices in tenant but not in a garden": "Henüz bir parka tanımlanmamış cihazlar",
    "Devices assigned to this park": "Bu parka tanımlanmış cihazlar",
    "Assignable Devices": "Tanımlanabilir Cihazlar",
    "Assigned Devices": "Tanımlanmış Cihazlar",
    "Select All": "Tümünü Seç",
    "Select Invert": "Seçimi Tersine Çevir",
    "No Devices Found": "Cihaz Bulunamadı",
    "Battery Saver Description": "6 saatte bir uyanır (period=21600)",
    "Normal Description": "30 dakikada bir uyanır (period=1800)",
    "Real Time Description": "Devamlı uyanık kalır",
    "Battery Modes Management by Garden": "Park Bazlı Pil Modu Yönetimi",
    "Device Battery Modes Management": "Cihaz Pil Modu Yönetimi",
    "Devices (available for Battery Mode management)": "Cihazlar (Pil Modu yönetimi için uygun)",
    battery_saver: "Pil Tasarrufu",
    real_time: "Canlı",
    normal: "Normal",
    "Irrigation report is available only for BLT devices connected to a water meter.": "Su sayacına bağlı BLT cihazları için sulama raporu mevcuttur.",
    "Device Irrigation Report": "Cihaz Sulama Raporu",
    "Locate on Map": "Haritayı Göster",
    "Redirects to Garden page": "Park sayfasına yönlendirir",
    "Close Map": "Haritayı Gizle",
    "Close Device View": "Cihaz Detaylarını Kapat",
    "The device you are looking for might have been removed or does not exist.": "Aradığınız cihaz kaldırıldı.",
    "Device is deleted or not found": "Cihaz silindi veya bulunamadı",
    "Garden Area": "Park Alanı",
    "Device Location": "Cihaz Konumu",
    "Other Devices": "Diğer Cihazlar",
    "Irrigation Zones": "Sulama Bölgeleri",
    "Edit zone name": "Bölge adını düzenle",
    "Display Smart Water Meter": "Akıllı Su Sayacını Göster",
    "Close Smart Water Meter": "Akıllı Su Sayacını Gizle",
    "No Connected Devices": "Bağlı Cihaz Yok",
    "Disconnect Device": "Cihazı Kaldır",
    "Loading Map": "Harita Yükleniyor",
    "Gardens Areas": "Park Alanları",
    "All Devices": "Tüm Cihazlar",
    "Empty Battery Devices": "Kapalı Cihazlar",
    "Device Battery Filter": "Pil Durumuna Göre Filtrele",
    "View Garden Details": "Park Detaylarını Görüntüle",
    "Optimization Settings": "Akıllı Sulama Ayarları",
    "Show Quick Plans": "Hızlı Planları Göster",
    "Hide Quick Plans": "Hızlı Planları Gizle",
    "Delete Quick Plan": "Hızlı Planı Sil",
    Now: "Şimdi",
    "Quick plan deleted successfully": "Hızlı plan silindi",
    Saving: "Kaydediliyor",
    "Active on days": "Etkin olduğu günler",
    "Show days": "Günleri göster",
    "Hide days": "Günleri gizle",
    "Add Quick Plan": "Hızlı Plan Ekle",
    "Plans of": "Planları",
    "Weekly Schedule": "Haftalık Planlar",
    "Load Template": "Taslak Yükle",
    "No saved templates": "Kayıtlı taslak yok",
    "Save Garden Template": "Park Taslağını Kaydet",
    "Are you absolutely sure you want to load this template? This action will overwrite all current plans!":
      "Seçili plan taslağını yüklemek istediğinize emin misiniz? Mevcut planlarınız silinecektir!",
    "Enter Template Name": "Taslak Adını Giriniz",
    "Template Name": "Taslak Adı",
    "Template applied": "Taslak yüklendi",
    "These devices were not included in the template": "Yüklenen taslakta bulunmayan cihazlar mevcut: ",
    "Failed to apply template": "Taslak yükleme işleminde hata",
    "Template saved": "Taslak kaydedildi",
    "Template applied successfully": "Taslak yüklendi",
    "Device plans were updated based on the selected template.": "Cihaz planları, seçili taslakta belirtilen şekilde güncellendi.",
    "Missing Devices": "Eksik Cihazlar",
    "These devices were included in the template but are no longer found in this garden": "Taslakta bulunan ancak parkta bulunmayan cihazlar: ",
    "New Devices Not in Template": "Taslakta bulunmayan yeni cihazlar mevcut",
    "These devices exist in the garden but were not included in the saved template": "Taslakta bulunmayan ancak parkta bulunan cihazlar: ",
    "No custom properties added yet.": "Henüz bir 'Özel Değer' eklenmedi.",
    "Garden Is Passive": "Park Pasif Durumda",
    "No Active Plans": "Aktif Plan Yok",
    "Has Upcoming Plan": "Yaklaşan Plan Mevcut",
    "Has No Upcoming Plans": "Yaklaşan Plan Yok",
    "Open Filters": "Filtreleri Aç",
    "Close Filters": "Filtreleri Kapat",
    Filters: "Filtreler",
    Tag: "Etiket",
    "No tags found": "Etiket bulunamadı",
    "All tags are in filtered state": "Tüm etiketler filtrelenmiş durumda",
    Clear: "Temizle",
    "Hide Garden List": "Park Listesini Gizle",
    batteryPercentage_all: "Tüm Cihazlar",
    batteryPercentage_full: "%100",
    batteryPercentage_threequarters: "> %75",
    batteryPercentage_half: "> %50",
    batteryPercentage_quarter: "> %25",
    "batteryPercentage_lt-quarter": "< %25",
    batteryPercentage_empty: "Kapalı Cihazlar",
    "No gardens found": "Park bulunamadı",
    "Apply Template": "Taslağı Uygula",
    "Cancel Preview": "Önizleme Modunu Kapat",
    "Preview Mode": "Önizleme Modu",
    "Rain Probability": "Yağmur Ihtimali",
    "Wind Speed": "Rüzgar Hızı",
    Clients: "Müşteriler",
    Employees: "Çalışanlar",
    "Affected Devices": "Etkilenen Cihazlar",
    "Upload Garden Image": "Park Görseli Yükle",
    "View Image": "Görüntüle",
    "Hi! How can I help you?": "Merhaba! Nasıl yardımcı olabilirim?",
    Send: "Gönder",
    "Grüngard Assistant": "Grüngard Asistan",
    "Type your message...": "Mesajınızı yazın...",
    "Number of Active Valves": "Aktif Bölge Sayısı",
    "Active Valve(s)": "Aktif Bölge",
    Saved: "Kaydedildi",
    Gizli: "Gizli",
    özel: "Özel",
    "Tag Gardens": "Park etiketleme",
    "You can tag gardens to organize them better": "Seçili etikete park ekleyebilirsiniz",
    "Create Tag": "Etiket yaratın",
    "Create tag for gardens": "Parklar için etiket yaratabilirsiniz",
    "Delete selected tags": "Seçili etiketleri sil",
    "Tag selected": "Etiket seçildi",
    item: "adet",
    items: "adet",
    "Audit Logs": "İşlem Kayıtları",
    "Templates viewed": "Taslaklar görüntülendi",
    "Show more": "Daha fazla",
    "Not Modified": "Değişiklik yok",
    "Watering disabled": "Sulama kapatıldı",
    "Watering enabled": "Sulama açıldı",
    "Unknown user": "Bilinmeyen kullanıcı",
    "No audit logs found": "İşlem kaydı bulunamadı",
    "Last Week": "Geçen Hafta",
    Older: "Daha Eski",
    "User:": "Kullanıcı:",
    "Raw Data": "Ham Veri",
    liters: "litre",
    gallon: "galon",
    gallons: "galon",
    "Update Device Location": "Cihaz Konumunu Güncelle",
    "Save Device Location": "Cihaz Konumunu Kaydet",
    "Cancel Location Update": "Konum Güncellemesini İptal Et",
    "Device List": "Cihaz Listesi",
    Valves: "Bölgeler",
    "Valve(s)": "Bölge",
    "Valve": "Bölge",
    "Filter Devices By Model": "Modele Göre Cihaz Filtrele",
    "Go to garden": "Parka Git",
    "Park updated": "Park güncellendi",
    "Garden deleted successfully": "Park silindi",
    "You are not authorized to delete this garden": "Bu parkı silme yetkiniz bulunmamaktadır.",
    "Failed to delete the garden": "Park silme işleminde hata",
    "Devices reordered": "Cihazlar sıralandı",
    "Optimization set": "Akıllı sulama ayarlandı",
    "Device assigned": "Cihaz atandı",
    "Device removed": "Cihaz çıkartıldı",
    "User assigned": "Kullanıcı atandı",
    "User unassigned": "Kullanıcı çıkartıldı",
    "Park tagged": "Park etiketlendi",
    "Park untagged": "Park etiketi kaldırıldı",
    "Template activated": "Hızlı plan aktifleştirildi",
    "Scheduler plans committed": "Zamanlayıcı planları kaydedildi",
    "The authentication code has been sent to": "Doğrulama kodu gönderildi:",
    "Manual watering": "Hemen Sula",
    "Hide manual watering": "Sulama Modunu Gizle",
    min: "dk",
    "Start Watering": "Sulama Başlat",
    "Stop Watering": "Sulamayı Durdur",
    "Create a custom plan": "Tekrar eden hızlı plan oluşturun",
    Day: "Gün",
    Hour: "Saat",
    Minute: "Dakika",
    "Custom Plan": "Özel Plan",
    "Zone Durations": "Bölge Süreleri",
    "Start Times": "Başlangıc Saatleri",
    "Every Day": "Her Gün",
    Monday_short: "Pt",
    Tuesday_short: "Sal",
    Wednesday_short: "Çar",
    Thursday_short: "Per",
    Friday_short: "Cum",
    Saturday_short: "Ct",
    Sunday_short: "Paz",
    "Last Connection Time": "Son Bağlantı Tarihi",
    "The phone number you've entered is in an invalid format": "Girdiğiniz telefon numarası geçersiz formatta",
    "Phone number should be in 1xxxxxxxxxx format": "Telefon numarası 5XXXXXXXXX formatında olmalıdır",
    User: "Kullanıcı",
    "Device created": "Cihaz oluşturuldu",
    "Device updated": "Cihaz güncellendi",
    "Device deleted": "Cihaz silindi",
    "Device deletion failed": "Cihaz silme işleminde hata",
    "Device location updated": "Cihaz konumu güncellendi",
    "Device name updated": "Cihaz adı güncellendi",
    "Park created": "Park oluşturuldu",
    "Park deleted": "Park silindi",
    "Park viewed": "Park görüntülendi",
    "Plan created": "Plan oluşturuldu",
    "Plan deleted": "Plan silindi",
    "Plan viewed": "Plan görüntülendi",
    "Quick plan template created": "Hızlı plan şablonu oluşturuldu",
    "Quick plan template deleted": "Hızlı plan şablonu silindi",
    "Quick plan templates viewed": "Hızlı plan şablonları görüntülendi",
    "Valve state updated": "Bölge durumu güncellendi",
    "Valve name updated": "Bölge adı güncellendi",
    "Tag created": "Etiket oluşturuldu",
    "Tag deleted": "Etiket silindi",
    "Inventory queried": "Envanter sorgusu",
    "Gardens added to tag": "Seçilen etikete {{count}} park eklendi",
    Devices_PL: "Cihaz",
    "Employee Name": "Çalışan Adı",
    "Shift Report": "Mesai Raporu",
    "Shift Start": "Mesai Başlangıcı",
    "Shift End": "Mesai Sonu",
    "Break Start": "Mola Başlangıcı",
    "Break End": "Mola Sonu",
    "Break Duration": "Mola Süresi",
    "Entry Location": "Giriş Konumu",
    "Exit Location": "Çıkış Konumu",
    "Inside the Garden": "Park içinde",
    "Outside of the Garden": "Park dışında",
    "Entry Notes": "Giriş Notları",
    "Exit Notes": "Çıkış Notları",
    Breaks: "Molalar",
    Entry: "Giriş",
    Exit: "Çıkış",
    "Shift Details": "Mesai Detayları",
    "View on Map": "Haritada Göster",
    "Entry Images": "Giriş Görselleri",
    "Exit Images": "Çıkış Görselleri",
    Preview: "Görüntüle",
    "Select a garden to view optimizations": "Akıllı Sulama ayarlarını görüntülemek için bir park seçin",
    "Optimizations for selected gardens": "Seçili parklar için akıllı sulama ayarları",
    "Please review the selected gardens and optimization settings before continuing.": "Devam etmeden önce seçili parkları ve akıllı sulama ayarlarını gözden geçirin.",
    "Gardens to be affected": "Akıllı sulamadan etkilenecek parklar",
    "Save Optimizations": "Akıllı Sulama Ayarlarını Kaydet",
    "Go Back": "Geri Dön",
    "Are you sure to delete this image?": "Bu görseli silmek istiyor musunuz?",
    Delete: "Sil",
    "These gardens will have their optimizations turned off": "Aşağıdaki parkların akıllı sulama özellikleri kapatılacak",
    "Cancel Optimizations": "Akıllı Sulamayı Kapat",
    "Display Alarm Limit": "Alarm Limitini Göster",
    "Close Alarm Limit": "Alarm Limitini Gizle",
    "You will be notified":
      "{{alarmSettingsDurationMinutes}} dakika içinde {{alarmSettingsLimitLitres}} litre üzerinde tüketim yapılması durumunda bilgilendirileceksiniz.",
    "Alarm settings saved.": "Alarm ayarları kaydedildi.",
    "Alarm limit will be disabled.": "Alarm limiti devre dışı bırakılacak.",
    Value: "Değer",
    "Optimizations cancelled successfully": "Akıllı Sulama Devre Dışı Bırakıldı",
    "Optimizations saved successfully": "Akıllı Sulama Ayarları Kaydedildi",
    "You are unauthorized to delete the work order": "İş emrini silme yetkiniz bulunmamaktadır.",
    Online: "Çevrimiçi",
    Offline: "Çevrimdışı",
    "Rain Forecast": "Yağmur Tahmini",
    "High Temperature": "Yüksek Sıcaklık",
    "High Winds": "Şiddetli Rüzgar",
    "Rain rule": "Yağmur ihtimali {{value}} değerinin üzerindeyse sulama yapma.",
    "Temperature rule": "Sıcaklık {{value}} değerinin üzerindeyse sulamayı artır.",
    "Wind rule": "Rüzgar hızı {{value}} değerinin üzerindeyse sulama yapma.",
    "Add at least one garden to list to configure optimizations.": "Akıllı sulama ayarlarını yapılandırmak için en az bir park ekleyin.",
    "Selected Gardens": "Seçilen Parklar",
    "Device valves data is missing": "Cihaz valf verileri eksik",
    "Rain Optimization Active": "Yağmur Optimizasyonu Aktif",
    "Wind Optimization Active": "Rüzgar Optimizasyonu Aktif",
    "Sun Optimization Active": "Sıcaklık Optimizasyonu Aktif",
    Legend: "Açıklama",
    "Delete All Plans": "Tüm Planları Sil",
    "This will permanently delete ALL plans on ALL devices in this garden.": "Bu işlem, bu Parktaki TÜM planları kalıcı olarak silecektir.",
    "All device plans will be removed and devices will be updated immediately.": "Tüm cihaz planları kaldırılacaktır.",
    "Active templates will be deactivated.": "Aktif hızlı planlar devre dışı bırakılacaktır.",
    "This operation is IRREVERSIBLE.": "Bu işlem GERİ ALINAMAZ.",
    "Please Type": "Onaylamak için",
    "to confirm:": "yazın:",
    "Garden plans deleted successfully": "Park planları başarıyla silindi",
    "Failed to delete garden plans": "Park planları silinemedi",
    "DELETE": "SİL",
    "Type {keyword} to confirm:": "Onaylamak için {keyword} yazın:",
    "Selected days not active on the garden": "Seçili günler aktif değil",
    "Enable them in the garden's watering days for this plan to run on those days.": "Oluşturduğunuz planın seçtiğiniz günlerde çalışması için lütfen parktaki ilgili sulama günlerini aktifleştiriniz.",
    "Park Plans deleted": "Park Planları Silindi",
    "This day is not active on the garden": "Seçili gün parkta aktif değil",
    "Mon": "Pzt",
    "Tue": "Sal",
    "Wed": "Çar",
    "Thu": "Per",
    "Fri": "Cum",
    "Sat": "Cmt",
    "no days": "gün yok",
    "every day": "her gün",
    "Confirm & Save": "Onayla ve Kaydet",
    "Go back": "Geri dön",
    "Review changes before saving": "Kaydetmeden önce değişiklikleri gözden geçirin",
    "All new plans apply only to": "Tüm yeni planlar yalnızca şu güne uygulanıyor:",
    "These days are disabled. No irrigation will be done on": "Kapalı olan günler mevcut. Planlar bu günlerde devre dışı olacak",
    "A quick-plan section was removed. The quick plan will be split into regular plans.": "Bir hızlı plan bölümü kaldırıldı. Hızlı plan normal planlara dönüştürülecek.",
    "Added": "Eklendi",
    "Removed": "Kaldırıldı",
    "plan(s)": "plan",
    "Active days set to": "Aktif günler şu şekilde ayarlandı",
    "{count} plan(s) added": "{count} plan eklendi",
    "{count} plan(s) removed": "{count} plan kaldırıldı",
    "Notifications": "Bildirimler",
    "Info": "Bilgi",
    "No Watering": "Sulama Yok",
    "Low Watering": "Düşük Sulama",
    "Show less": "Daha az göster",
    "Show all": "Tümünü göster",
    "Water Consumption Alarm": "Su Tüketim Alarmı",
    "Location": "Konum",
    "Resolve": "Durdur",
    "No notifications": "Bildirim bulunmamaktadır",
    "Save Order": "Sırayı Kaydet",
    "Garden order saved successfully": "Park sıralaması kaydedildi",
    "Failed to save garden order": "Sıralama kaydında hata",
    "Drag gardens to reorder (Favorites will always appear at the top)": "Sıralamayı değiştirmek için sürükleyiniz (Favori parklar her zaman en üstte görünür)",
    "Order Gardens": "Parkları Sırala",
    "Devices that did not water": "Sulama Yapmayan Cihazlar",
    "Offline devices": "Çevrimdışı Cihazlar",
    "Toggle to enable or disable smart water meter for this device": "Bu cihaz için akıllı su sayacını etkinleştirin veya devre dışı bırakın.",
    "Gardens unassigned successfully": "Park ataması kaldırıldı.",
    "Performed by": "Kullanıcı",
    "Date": "Tarih",
    "Overlapping plans detected": "Çakışan planlar tespit edildi",
    "These plans overlap on the same valve and must be resolved before saving": "Lütfen kaydetmeden önce çakışan planları kontrol ediniz",
    "No water flow": "Su geçişi yok",
    "No irrigation report": "Sulama kaydı yok",
    "All valves off": "Tüm vanalar kapalı",
    "Canceled by weather": "Hava optimizasyonu ile iptal",
    "Cause not determined": "Sebep belirlenemedi",
    "The device reported a log, but no water passed. Check the meter, valves and line.": "Cihaz kayıt gönderdi ancak su geçmedi. Sayacı, vanaları ve hattı kontrol edin.",
    "The device was reachable but sent no irrigation log for its plan.": "Cihaza ulaşılabiliyordu ancak planı için sulama kaydı göndermedi.",
    "The device has not connected in the last 24 hours.": "Cihaz son 24 saattir bağlanmadı.",
    "Every valve on the device is switched off, so no plan can run.": "Cihazdaki tüm vanalar kapalı olduğu için hiçbir plan çalışamaz.",
    "Rain or wind optimization canceled this watering. No action needed.": "Yağmur veya rüzgar optimizasyonu bu sulamayı iptal etti. İşlem yapmanıza gerek yok.",
    "This device did not water, but no specific cause was recorded.": "Bu cihaz sulama yapmadı ancak belirli bir sebep kaydedilmedi.",
    "Last seen": "Son bağlantı",
    "Connected by": "Son bağlanan kullanıcı",
    "Never connected": "Hiç bağlanmadı",
    "min canceled": "dk iptal edildi",
    "valves off": "vana kapalı",
    "Expected": "Beklenen",
    "no log received": "kayıt alınmadı",
    "measured flow": "ölçülen akış",
    "reported": "bildirilen",
    "Why watering did not happen": "Sulama yapılmama sebebi",
    "This device has been removed since the notification was sent.": "Bu cihaz bildirim gönderildikten sonra silinmiştir.",
    "Select the gardens to update": "Güncellenecek parkları seçiniz",
    "Watering status to apply": "Uygulanacak sulama durumu",
    "Add at least one garden to list to apply a watering status.": "Sulama durumunu değiştirmek için en az bir park seçiniz.",
    "Watering features for the devices in the selected gardens will be enabled.": "Seçili parklardaki cihazların sulama özellikleri aktifleştirilecektir.",
    "Watering features for the devices in the selected gardens will be disabled. Scheduled plans will not run while watering is passive.":
      "Seçili parklardaki cihazların sulama özellikleri devre dışı bırakılacaktır. Sulama durumu kapalıyken sulama planları uygulanmaz.",
    "Toggle Watering Status": "Sulama Durumunu Değiştir",
    "selected gardens will change": "seçili parklar güncellenecek",
    "Watering will be enabled for the gardens below.": "Seçili parklardaki sulama durumu aktifleştirilecek",
    "Watering will be disabled for the gardens below.": "Seçili parklardaki sulama durumu devre dışı bırakılacak",
    "Enable Watering": "Aktifleştir",
    "Disable Watering": "Devre Dışı Bırak",
    "Current Status": "Mevcut Durum",
    "Apply": "Uygula",
    "Watering status updated successfully": "Sulama durumu güncellendi",
    "Failed to update watering status": "Sulama durumu güncellenemedi",
    "Bulk watering status update failed": "Sulama durumu güncellemesi başarısız oldu",
    "gardens could not be updated": "park güncellenemedi",
    "devices could not be notified": "cihaza ulaşılamadı",
    "Watering active": "Sulama yapılıyor",
    "reconnecting": "yeniden bağlanılıyor",
    "Starting watering": "Sulama başlıyor",
    "Stopping watering": "Sulama durduruluyor",
    "The device hasn't responded yet. Waiting for the device to come online...": "Cihaz henüz yanıt vermedi. Cihaz ile iletişim kuruluyor...",
    "Waiting for the device to respond.": "Cihazdan yanıt bekleniyor"
  },
};

const tenantWordMap = {
  en: {
    garden: {
      default: "garden",
      pro: "site",
    },
    gardens: {
      default: "gardens",
      pro: "sites",
    },
    Garden: {
      default: "Garden",
      pro: "Site",
    },
    Gardens: {
      default: "Gardens",
      pro: "Sites",
    },
  },
};

const applyTenantReplacements = (text, locale, tenantType) => {
  if (locale !== "en") return text; // Only English changes

  const rules = tenantWordMap[locale];
  if (!rules) return text;

  let result = text;

  Object.keys(rules).forEach((word) => {
    const replacement = tenantType === "pro" ? rules[word].pro : rules[word].default;

    result = result.replace(new RegExp(`\\b${word}\\b`, "g"), replacement);
  });

  return result;
};

const t = (text, params = {}) => {
  const locale = localStorage.getItem("locale") || "en";
  const tenantType = localStorage.getItem("type") || "basic";

  const dict = translations[locale] || translations.en;

  let translated = dict[text] || text;

  // Replace params
  Object.keys(params).forEach((key) => {
    translated = translated.replace(new RegExp(`{{\\s*${key}\\s*}}`, "g"), params[key]);
  });

  // 👇 Apply tenant-specific wording
  translated = applyTenantReplacements(translated, locale, tenantType);

  return translated;
};

export default t;
